var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6148 15.1548L12.4844 12.0245M12.4844 12.0245C13.0199 11.489 13.4446 10.8533 13.7344 10.1537C14.0242 9.45412 14.1734 8.70428 14.1734 7.94703C14.1734 7.18978 14.0242 6.43995 13.7344 5.74034C13.4446 5.04073 13.0199 4.40505 12.4844 3.86959C11.949 3.33414 11.3133 2.90939 10.6137 2.6196C9.91408 2.32982 9.16424 2.18066 8.40699 2.18066C7.64974 2.18066 6.89991 2.32982 6.2003 2.6196C5.50069 2.90939 4.86501 3.33414 4.32955 3.86959C3.24815 4.951 2.64062 6.4177 2.64062 7.94703C2.64063 9.47637 3.24815 10.9431 4.32955 12.0245C5.41096 13.1059 6.87766 13.7134 8.40699 13.7134C9.93633 13.7134 11.403 13.1059 12.4844 12.0245Z",
    stroke: "#2D61D6",
    strokeWidth: 1.00653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6d5b9121e371b31dbfd27de21f5f84c6.svg";
export { ForwardRef as ReactComponent };